import { Map, fromJS } from 'immutable'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { SET_CURRENT_TASK, CHECK_CURRENT_TASK } from './actions'

const INITIAL_STATE = new Map(
  fromJS({
    logEntry: null,
    lastOccurence: null,
    name: null,
    duration: null,
    startedAt: null,
    type: null,
  })
)

export const currentTask = createReducer(INITIAL_STATE, {
  [SET_CURRENT_TASK]: (state, { payload }) => new Map(payload),

  [CHECK_CURRENT_TASK.FULFILLED]: (state, { payload }) => state.merge(payload),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/current-task/reducers.js